<div [style.background]="backCol" [style.border-color]="borderColor" class="purple-pill {{pillDefaultColor}} {{pillCustomClass}}">
  <p [style.color]="textColor" class="purple-pill-text">
    {{pillText}}
  </p>
</div>